import React, { useState } from 'react';
import classes from "./form.module.css"
import InputField from "../../../containers/inputField/inputField";
import { sixYardAxios } from '../../../../sixYardAxios';
import qs from "qs";
import PromptMessage from "../../../containers/promptMessage/promptMessage";

const Form = (props) => {
    const isEnglish = parseInt(localStorage.getItem('language')) === 1;
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [controls, setControls] = useState({
        fullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Full Name" : "الاسم الكامل",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: isEnglish ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: isEnglish ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: isEnglish ? "Phone Number" :  "رقم الهاتف",
            valid: false,
            touched: false
        },
        message: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder:  isEnglish ? "Enter your message" :   "أدخل رسالتك",
            },
            value: "",
            label: isEnglish ? "Message" :    "الرسالة",
            valid: false,
            touched: false,
        },
    });
    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    const inputChangedHandler = (event, controlName) => {
        const value = (controlName === 'phone' || controlName.toLowerCase().includes('date')) ? event : event.target.value;
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value,
                valid: checkValidity(value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
    }
    const clearControls = () => {
        const updatedControls = {
            ...controls
        };
        for (let key in controls) {
            updatedControls[key] = {
                ...controls[key],
                value: "",
                valid: false,
                touched: false
            };
        }
        setControls(updatedControls);
    };
    const submitHandler = e => {
        e.preventDefault();
        sixYardAxios({
            method: "post",
            url: "/contact",
            data: qs.stringify({
                "name": controls.fullName.value,
                "email": controls.email.value,
                "phone": controls.phone.value.dialCode+controls.phone.value.number,
                "message": controls.message.value
            })
        })
            .then(response => {
                clearControls();
                setSuccess(response.data.message);
            })
            .catch(error => {
                setError(error.response.data.message);
            });
    };
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            {form}
            <div>
                <button type="submit" className={classes.submitButton}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "SEND" : "إرسال"}
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                        alt=""
                        className={classes.submitIcon}
                    />
                </button>
            </div>
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
            {success && <PromptMessage message={success} status='CONGRATULATIONS' successMessage button='CLOSE' click={() => setSuccess(false)} />}
        </form>
    )
}
export default Form;